import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button, FormText } from "reactstrap";

export const FormMicTypeSample = (props) => {
    const {
        toggle, loading, handleInputChange, validaciones,
        name, abbreviation,
        methodAction, button, closeDialog
    } = props;

    const {
        name_valid, abbreviation_valid,
    }=validaciones

    
    return (
        <Form className='' role="form" onSubmit={methodAction}>
          
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre<span className='f-16' style={{color:"#0079C7"}}>*</span></Label>
                        <Input 
                            className='input-admision'
                            type='text'
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                            invalid={name_valid}
                        />
                        <FormFeedback>Minimo 3 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Abreviatura <span className='f-16' style={{color:"#0079C7"}}>*</span></Label>
                        <Input 
                            className='input-admision'
                            type='text'
                            name="abbreviation"
                            onChange={handleInputChange}
                            value={abbreviation}
                            autoComplete="off"
                            invalid={abbreviation_valid}
                        />
                        <FormFeedback>Minimo 2 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
           
            <ModalFooter>
                <Button color="primary" type="submit" size='sm' className={loading ? "disabled progress-bar-animated progresss-bar-striped":""}>
                    {button}
                </Button>
                <Button size="sm" color='danger' type='button' onClick={closeDialog}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}